import React, { useState } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { TitleText, Text } from '../../lib/styles/styledAbout';
import palette from '../../lib/styles/palette';

// 미모티콘 수정 필요
import reviewer1 from '../../assets/about/reviewer1.png';
import reviewer2 from '../../assets/about/reviewer2.png';
import reviewer3 from '../../assets/about/reviewer3.png';
import reviewer4 from '../../assets/about/reviewer4.png';


import up from '../../assets/recruitment/up.png';
import down from '../../assets/recruitment/down.png';

const Review = () => {
  const isTablet = useMediaQuery({
    query: '(max-width: 1023px)',
  });
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });

  const [detail, setDetail] = useState(false); // 드롭다운 세모 이미지

  const _handleClick = () => {
    setDetail(!detail);
  };

  return (
    <>
      {/* 모바일 - 제목 모달 */}
      {isMobile && (
        <DropdownContainer onClick={_handleClick}>
          <DropdownText green>우수 활동 퍼비</DropdownText>
          <DropdownText>의 활동 후기</DropdownText>
          {detail ? (
            <DropdownImg src={up} alt="up" />
          ) : (
            <DropdownImg src={down} alt="down" />
          )}
        </DropdownContainer>
      )}

      {(isMobile && detail) || (!isMobile && !detail) ? (
        <>
          {isMobile ? (
            <></>
          ) : (
            <TitleContainer>
              <TitleText green>우수 활동 퍼비</TitleText>
              <TitleText>의 활동 후기</TitleText>
            </TitleContainer>
          )}

          <ReviewContainer>
            <Reviewer src={reviewer1} />
            <ContentBox>
              <Text>
              UXUI의 이론부터 기초 실습까지 기획된 커리큘럼 덕분에 
              실제 프로젝트를 진행할 때 많이 헤매지 않고 진행할 수 있었던 것 같습니다! 
              개발자와 함께 프로젝트를 진행하고 실제 배포까지 해본다는 점이 정말 좋은 
              경험이었습니다. 좋은 팀원들 만나서 함께 작업할 수 있어서 행복했어요☺️ 이펍 짱
              </Text>

            </ContentBox>
          </ReviewContainer>

          <ReviewContainer>
            {isTablet ? (
              <>
                <Reviewer src={reviewer2} />
                <ContentBox>
                  <Text>
                    안녕하세요. 이펍 5기 프론트엔드 인턴 우윤수입니다. HTML, CSS의 왕기초만 알던 제가 
                  이펍과 함께 프론트엔드로 활동하면서 성장하여 우수 퍼비에도 선정되다니 정말 영광입니다.
                   이펍은 커리큘럼도 아주 잘 짜여 있고, 열정만 가득하다면 정말 많은 성장을 할 수 있는
                   동아리라고 생각합니다. 특히 SWS, AWA 총 두 번의 프로젝트를 통해 개발 실력은 물론 
                   협업 능력까지 함께 키울 수 있어서 정말 좋았습니다. 정말 좋은 사람들이 가득해서, 
                   이펍을 통해 알게 된 인연으로 학교 생활까지 즐겁게 했던 것 같아요! 그만큼 얻어가는 
                   것이 많으니 새로 퍼비가 될 신입 기수분들도 경험이 없다고 걱정하지 마시고, 열정을 
                   가지고 도전해서 많은 성장 이루셨으면 좋겠습니다. 1년간 정말 즐거웠고, 바쁜 와중에도 
                   동아리를 잘 이끌어주신 운영진 분들께도 감사하다는 말씀을 전하고 싶습니다.
                  </Text>

                </ContentBox>
              </>
            ) : (
              <>
                <ContentBox>
                  <Text>
                  안녕하세요. 이펍 5기 프론트엔드 인턴 우윤수입니다. HTML, CSS의 왕기초만 알던 제가 
                  이펍과 함께 프론트엔드로 활동하면서 성장하여 우수 퍼비에도 선정되다니 정말 영광입니다.
                   이펍은 커리큘럼도 아주 잘 짜여 있고, 열정만 가득하다면 정말 많은 성장을 할 수 있는
                   동아리라고 생각합니다. 특히 SWS, AWA 총 두 번의 프로젝트를 통해 개발 실력은 물론 
                   협업 능력까지 함께 키울 수 있어서 정말 좋았습니다. 정말 좋은 사람들이 가득해서, 
                   이펍을 통해 알게 된 인연으로 학교 생활까지 즐겁게 했던 것 같아요! 그만큼 얻어가는 
                   것이 많으니 새로 퍼비가 될 신입 기수분들도 경험이 없다고 걱정하지 마시고, 열정을 
                   가지고 도전해서 많은 성장 이루셨으면 좋겠습니다. 1년간 정말 즐거웠고, 바쁜 와중에도 
                   동아리를 잘 이끌어주신 운영진 분들께도 감사하다는 말씀을 전하고 싶습니다.
                  </Text>
                </ContentBox>
                <Reviewer src={reviewer2} />
              </>
            )}
          </ReviewContainer>

          <ReviewContainer>
            <Reviewer src={reviewer3} />
            <ContentBox>
                  <Text>
                  1년 동안 EFUB 프론트엔드 활동을 하며 웹 개발의 기초부터 실제 서비스 구현까지 
                    전반적인 개발 과정을 경험할 수 있었습니다. 자바스크립트는 이전에도 사용해본 경험이
                   있었지만, 타입스크립트는 이론 위주로만 학습했던 상태였는데, EFUB 프로젝트를 통해 
                   이를 실제 코드에 적용해 보면서 타입 시스템과 구조화된 개발 방식에 대해 제대로 
                   이해할 수 있었습니다. 또한 React를 기반으로 한 프로젝트를 넘어 Next.js 프레임워크를 
                   활용한 개발을 경험하며, 프레임워크 선택에 따른 구조 차이와 렌더링 방식 등 한 단계 확장된 
                   프론트엔드 개발 관점을 기를 수 있었습니다. 백엔드 파트, 디자인 파트와 함께 협업하며 
                   실제 서비스 개발 과정과 유사한 환경을 경험할 수 있었고, 제한된 기간 안에 프로젝트를 
                   완성해야 하는 상황 속에서 단순히 기능을 구현하는 것을 넘어서 사용자 경험까지 
                   고려하는 시야를 갖게 되었습니다.
                  </Text>
            </ContentBox>
          </ReviewContainer>

          <ReviewContainer>
            {isTablet ? (
              <>
                <Reviewer src={reviewer4} />
                <ContentBox>
                  <Text>
                    HTML, CSS, JavaScript의 기초만 아는 상태에서 이펍에 들어오게 되어서 처음엔
                    걱정이 많았는데, 매주 세미나를 진행하면서 많이 배우고 지식을 넓혀갈 수 있었어요.
                    탄탄한 커리큘럼이 받쳐줘서 1학기 때 배웠던 지식을 바탕으로 진행되는 SWS는 힘들기도
                    했지만, 몰입한 만큼 얻어가는 게 정말 많았던 가치 있는 활동이었습니다.
                    이펍에서의 시간은 단순한 동아리 활동 그 이상이었어요. 퍼비들과 공부하고 개발하면서
                    소중한 친구들을 얻을 수 있어서 너무 행복했습니다!! 이화 최고의 동아리 이펍 짱♡
                  </Text>
                </ContentBox>
              </>
            ) : (
              <>
                <ContentBox>
                  <Text>
                    HTML, CSS, JavaScript의 기초만 아는 상태에서 이펍에 들어오게 되어서 처음엔
                    걱정이 많았는데, 매주 세미나를 진행하면서 많이 배우고 지식을 넓혀갈 수 있었어요.
                    탄탄한 커리큘럼이 받쳐줘서 1학기 때 배웠던 지식을 바탕으로 진행되는 SWS는 힘들기도
                    했지만, 몰입한 만큼 얻어가는 게 정말 많았던 가치 있는 활동이었습니다.
                    이펍에서의 시간은 단순한 동아리 활동 그 이상이었어요. 퍼비들과 공부하고 개발하면서
                    소중한 친구들을 얻을 수 있어서 너무 행복했습니다!! 이화 최고의 동아리 이펍 짱♡

                  </Text>
                </ContentBox>
                <Reviewer src={reviewer4} />
              </>
            )}
          </ReviewContainer>

          {/* <ReviewContainer>
            <Reviewer src={reviewer5} />
            <ContentBox>
              <Text>
              </Text>
            </ContentBox>
          </ReviewContainer>

          <ReviewContainer>
            {isTablet ? (
              <>
                <Reviewer src={reviewer6} />
                <ContentBox>
                  <Text>
                  </Text>
                </ContentBox>
              </>
            ) : (
              <>
                <ContentBox>
                  <Text>
                  </Text>
                </ContentBox>
                <Reviewer src={reviewer6} />
              </>
            )}
          </ReviewContainer>

          <ReviewContainer>
            <Reviewer src={reviewer7} />
            <ContentBox>
              <Text>
              </Text>
            </ContentBox>
          </ReviewContainer> */}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Review;

const DropdownContainer = styled.div`
  padding: 1rem;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: rgba(225, 225, 225, 0.15);
  border-radius: 10px;
  justify-content: center;
  cursor: pointer;
  position: relative;
  margin-bottom: 30px;
`;

const DropdownText = styled.div`
  font-family: 'Roboto';
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => (props.green ? palette.green : 'white')};
`;

const DropdownImg = styled.img`
  position: absolute;
  right: 20px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 100px 0px;
`;

const Reviewer = styled.img`
  width: 300px;
  @media (max-width: 1023px) {
    width: 240px;
  }
  @media (max-width: 767px) {
    width: 180px;
  }
`;

const ReviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 100px;
  align-items: center;
  gap: 5rem;
  @media (max-width: 1023px) {
    flex-direction: column;
  }
  @media (max-width: 767px) {
    margin-bottom: 50px;
  }
`;

const ContentBox = styled.div`
  width: 700px;
  padding: 30px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  @media (max-width: 767px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    padding: 15px;
  }
`;
